import React, { useEffect, useState } from "react";
import LoadingWheel from "../../Shared/LoadingWheel";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend } from 'chart.js';
import { Doughnut, Line } from "react-chartjs-2";

const ReviewRatingsPie = ({ stats }) => {
  const [graph, setGraph] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    if (!stats.isLoading) {
      var newGraph = <Doughnut id="areaChart" options={options} />;

      // var component = document.getElementById("areaChart");
      var component = document.createElement("canvas");
      var ctx = component.getContext("2d");

      const data = getData(stats.data.reviewRatings);

      newGraph = React.cloneElement(newGraph, { data: data })

      setGraph(newGraph);
      setIsLoading(false);
      // console.log("referrers finished")
    }
  }, [stats.isLoading, stats.data])

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        display: true
      },
      title: {
        display: false,

      },
    }
  };

  const getData = (unsorted) => {
    const statsArray = Object.entries(unsorted);
    const stats = statsArray.sort((a, b) => Number(a[0]) - Number(b[0]));

    const formattedData = stats.map((reviewSite) => {
      return reviewSite[1];
    })

    const labels = stats.map((reviewSite) => {
      return reviewSite[0];
    })

    // let bgColours = [];
    // for (let i = 0; i < stats.length; i++) {
    //   bgColours.push(`rgb(${225 + i * 200 / stats.length},${i * 250 / stats.length},${200 + i * 200 / stats.length})`)
    // }

    const bgColours = [
      "rgb(54, 162, 235)",   // Soft blue
      "rgb(255, 206, 86)",   // Warm yellow
      "rgb(75, 192, 192)",   // Teal
      "rgb(153, 102, 255)",  // Lavender purple
      "rgb(255, 99, 132)",   // Soft red
      "rgb(255, 159, 64)",   // Orange
      "rgb(201, 203, 207)",  // Light gray
      "rgb(100, 181, 246)",  // Sky blue
      "rgb(129, 199, 132)",  // Soft green
      "rgb(244, 143, 177)"   // Light pink
    ];



    return {
      type: "donut",
      labels: labels,
      datasets: [
        {
          data: formattedData,
          backgroundColor: bgColours,
          hoverOffset: 4
        },
      ],
    }
  };

  return (
    <div className="px-8 py-4 w-full">
      <h1 className="text-base font-normal text-gray-800  lg:pt-2 mb-4">Review Ratings</h1>

      <hr className="" />

      {stats.isLoading ? (
        <div className="flex p-10 bg-white justify-center">
          <LoadingWheel width="w-12" height="h-12" />
        </div>
      ) : (
        <>
          <div className="mt-2 p-8">
            {!isLoading && graph}
          </div>
        </>
      )}
    </div>
  )
}

export default ReviewRatingsPie;
